import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { SystemTomos } from './components/sections/SystemTomos';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  return <div className="w-full min-h-full bg-cream text-navy antialiased" data-id="element-0" data-mp="23vkuoemiy5k6">
      <MetaPixel data-id="element-1" data-mp="23t8ea5wf0398" />
      <main className="w-full overflow-x-hidden" data-id="element-2" data-mp="3ijxsgzk2wgo4">
        <Hero data-id="element-3" data-mp="3ijfwm41bw4gq" />
        <Stats data-id="element-4" data-mp="3ijpdn24eb1aa" />
        <BeforeAfter data-id="element-5" data-mp="3ii4r9zs8ioni" />
        <PainPoints data-id="element-6" data-mp="3mlatmwc87vop" />
        <SystemTomos data-id="element-7" data-mp="3mkhmhu9cv461" />
        <Bonuses data-id="element-8" data-mp="3mjztr7lwj82v" />
        <Offer data-id="element-9" data-mp="3mjg93j4va5l5" />
        <Guarantee data-id="element-10" data-mp="3rc9d24sih9w6" />
        <Testimonials data-id="element-11" data-mp="3rbrbqtqzs5he" />
        <About data-id="element-12" data-mp="3rdkhm6ts6loc" />
        <FAQ data-id="element-13" data-mp="3rcsuzli5vya7" />
        <FinalCTA data-id="element-14" data-mp="3recdlirailf5" />
      </main>
      <PurchasePopup data-id="element-15" data-mp="5opiv1o0k3w" />
      <FloatingCTA data-id="element-16" data-mp="4wv3njt0sf7" />
    </div>;
}